.segment {
  --ixf-date-picker-segment-padding: 2px;

  font-family: var(--ixf-font-family-mono);
  font-size: 0.875rem;
  line-height: 1rem;
  box-sizing: content-box;
  text-align: end;
  padding: var(--ixf-date-picker-segment-padding);
  border-radius: var(--ixf-border-radius-1);
  text-transform: uppercase;

  &.withModifiedPlaceholder {
    text-transform: none;
  }

  &.literal {
    padding: var(--ixf-date-picker-segment-padding) 0;
  }

  &:focus {
    background: var(--ixf-color-neutral-lt);
    outline: none;
  }
}
